import { t } from "@/i18n-js/instance";
import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";

export interface GetBlockNameParams {
  block?: BaseBlock | null;
  meta?: ComponentMeta | null;
}

export const getBlockName = ({ block, meta }: GetBlockNameParams) => {
  if (typeof block?.meta?.name === "string") {
    return block.meta.name;
  }

  const i18nKey = meta?.nameI18n;
  const fallbackName = meta?.name || block?.type || "";
  return i18nKey ? t(i18nKey, { defaultValue: fallbackName }) : fallbackName;
};
